import { cn } from '@/lib/utils';
import {
  DEVELOPMENT_MANDATE_SECTIONS,
  type DevelopmentMandateSelections,
} from '@/config/developmentMandate';

type DevelopmentMandateFormProps = {
  value: DevelopmentMandateSelections;
  onChange: (next: DevelopmentMandateSelections) => void;
  compact?: boolean;
};

export default function DevelopmentMandateForm({
  value,
  onChange,
  compact = false,
}: DevelopmentMandateFormProps) {
  const toggleOption = (sectionKey: keyof DevelopmentMandateSelections, optionValue: string) => {
    const current = value[sectionKey];
    const next = current.includes(optionValue)
      ? current.filter((v) => v !== optionValue)
      : [...current, optionValue];
    onChange({ ...value, [sectionKey]: next });
  };

  return (
    <div className={cn('space-y-5', compact && 'space-y-4')}>
      {DEVELOPMENT_MANDATE_SECTIONS.map((section) => (
        <section key={section.key} className="space-y-2">
          <div>
            <h3
              className={cn(
                'font-sans font-semibold text-white',
                compact ? 'text-sm' : 'text-base',
              )}
            >
              {section.title}
            </h3>
            <p className="text-xs text-white/50 font-sans mt-0.5">{section.description}</p>
          </div>
          <div className="flex flex-wrap gap-2">
            {section.options.map((option) => {
              const selected = value[section.key].includes(option.value);
              return (
                <button
                  key={option.value}
                  type="button"
                  disabled={option.disabled}
                  onClick={() => toggleOption(section.key, option.value)}
                  className={cn(
                    'rounded-sm border px-3 py-2 text-left text-sm font-sans transition-colors',
                    option.disabled && 'cursor-not-allowed opacity-40',
                    selected
                      ? 'border-gold-button bg-gold-button/15 text-gold-button'
                      : 'border-[#3a3a3a] text-white/75 hover:border-gold-button/50 hover:text-white',
                  )}
                >
                  <span className="block">{option.label}</span>
                  {option.description && (
                    <span className="block text-xs text-white/45 mt-0.5">{option.description}</span>
                  )}
                  {option.disabled && (
                    <span className="block text-[10px] uppercase tracking-wider text-white/35 mt-1">
                      Coming soon
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}
